<template>
  <div class="flex flex-row gap-4 items-top w-full p-4 mb-4 rounded-lg text-left" :class="color">
    <div v-if="showIcon" class="text-2xl">{{ icon }}</div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalloutComponent',
  components: {
  },
  props: {
    type: String,
    showIcon: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
  ],
  data() {
    return {
    }
  },
  beforeMount() {
  },
  watch: {
  },
  methods: {
  },
  computed: {
    color() {
      switch(this.type) {
       case 'info':
          return { 'bg-blue-100': true }
        case 'warning':
          return { 'bg-yellow-100': true }
        default:
         throw new Error('Callout type', this.type, 'does not exist')
      }
    },
    icon() {
      switch(this.type) {
       case 'info':
          return 'ℹ️'
        case 'warning':
          return '⚠️'
        default:
         throw new Error('Callout type', this.type, 'does not exist')
      }
    },
  }
}
</script>